<template>
    <div>
        <component v-if="layout" :is="layout"></component>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import app from '../layouts/app'
    import sinmenu from '../layouts/sinmenu'

    export default {
        components: {app, sinmenu},
        computed: {
            ...mapGetters('config', ['layout']),
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/App.vue